import React, { useState, useEffect, Fragment } from 'react';

//import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
    Button,
    Alert,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText,
} from "react-bootstrap";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import "./WordByWordUpdate.css";
import "./bubble.css";
//import logo from "./sethu.ai_1.jpg";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { AppBar, Link, Toolbar, Typography } from "@mui/material";
import { ThemeProvider } from '@mui/material'


function WordByWordUpdateGita() {
    const [item, setItems] = useState([])
    const [text, setText] = useState('Hello World');
    const [message, setMessage] = useState('');
    const [qmessage, setQMessage] = useState('Provide summary of bhagavadgita chapter 2');
    const [displayedText, setDisplayedText] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState('Loading');

    const [isPaused, setIsPaused] = useState(false);
    const [utterance, setUtterance] = useState(null);
    const [voice, setVoice] = useState(null);
    const [pitch, setPitch] = useState(1);
    const [rate, setRate] = useState(1);
    const [volume, setVolume] = useState(1);
    const [talk, setTalk] = useState(false);
    const [speak, setSpeak] = useState(false);

    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    // if (!browserSupportsSpeechRecognition) {
    //     setQMessage("Browser doesn't support speech recognition.");
    // }

    useEffect(() => {
        const synth = window.speechSynthesis;
        const u = new SpeechSynthesisUtterance(message);
        const voices = synth.getVoices();

        setUtterance(u);
        setVoice(voices[0]);

        return () => {
            synth.cancel();
        };
    }, [message]);

    const handlePlay = () => {
        const synth = window.speechSynthesis;

        if (isPaused) {
            synth.resume();
        } else {
            utterance.voice = voice;
            utterance.pitch = pitch;
            utterance.rate = rate;
            utterance.volume = volume;
            synth.speak(utterance);
        }

        setIsPaused(false);
    };

    const handlePause = () => {
        const synth = window.speechSynthesis;

        synth.pause();

        setIsPaused(true);
    };

    const handleStop = () => {
        const synth = window.speechSynthesis;

        synth.cancel();

        setIsPaused(false);
        setSpeak(false);
    };





    const addItem = (qmessage, displayedText) => {
        //const newItem = `Item ${items.length + 1}`;
        setItems(prevItems => [...prevItems, { qmessage, displayedText }]);
    };



    //useEffect(() => {
    const updateTextWithDelay = async () => {
        const words = message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        addItem("<Employee >" + qmessage, message)

    };
    const aupdateTextWithDelay = async (a_message) => {
        setDisplayedText(" ");
        const words = a_message.split(' ');

        for (const word of words) {
            // Simulate a delay using setTimeout
            await sleep(150); // Adjust the delay time as needed

            // Update the displayedText state word by word
            setDisplayedText((prevText) => prevText + ' ' + word);

        }
        //addItem("<Employee >" + qmessage, "<Insurance Bot >" + a_message)
        addItem(" " + qmessage, " " + a_message);
        setLoading(false);
        setSpeak(true);

    };

    //    updateTextWithDelay();
    //}, [text]);

    useEffect(() => {
        const interval = setInterval(() => {

            setDisplayedText(prevText => prevText.includes('Loading') ? prevText + '.' : prevText);

        }, 500);

        return () => clearInterval(interval);
    }, []);

    // Utility function to simulate sleep
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const handleSendMessage = () => {
        setDisplayedText("Loading");
        setLoading(true);
        setMessage("");

        fetch("http://157.173.222.203:8080/g_generate?query=" + qmessage)
            .then((response) => response.json())
            .then((data) => {

                setMessage(" " + data.response);

                aupdateTextWithDelay(data.response);


            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });

    };
    const handleInputChange = (e) => {
        setQMessage(e.target.value);
        setDisplayedText('');
        //console.log(qmessage)
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };
    const handleMouseDown = (event) => {
        event.preventDefault();
        console.log("down");
        SpeechRecognition.startListening();
        setTalk(true);
        //setQMessage(transcript);


    };

    const handleMouseUp = (event) => {
        event.preventDefault();
        SpeechRecognition.stopListening();
        setTalk(false);
        setQMessage(transcript);
        console.log(transcript);
        resetTranscript();

    };

    const handleMouseLeave = () => {

        SpeechRecognition.stopListening();
        setQMessage(transcript);
        console.log(transcript);
        setTalk(false);
        resetTranscript();


    };


    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <div className='fillOutPage property'>
                <Header />

                {/* <main className="my-5 py-5"> */}
                <Container className="px-0">
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">

                        <Card>
                            <Typography variant="h5" style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                                LLM based BOT Application for Bhagavad-Gita Learning

                            </Typography></Card>
                    </Row>
                    <Row className="pt-2 pt-md-5 w-100 px-4 px-xl-0 position-relative">

                        <div className="App">
                            {loading ? (<Card>
                                <div class="middle">
                                    {/* <p class="left-align">{" " + qmessage}</p> */}

                                    <p class="left-align">{" " + displayedText}</p>
                                </div>
                            </Card>) : (<Card>
                                <div className="center">
                                    <ul className="message-list">
                                        {item.map((imessage, index) => (
                                            <Fragment key={index}>
                                                <p className="right-align chat-bubble user">{imessage.qmessage}</p>
                                                <p className="left-align chat-bubble bot">{imessage.displayedText}</p>
                                            </Fragment>
                                        ))}
                                        {/* {item.map((imessage, index) => (
                                    <p class="left-align" key={index}>{imessage}</p>
                                ))} */}
                                    </ul>
                                </div>
                            </Card>)}


                            <Card>
                                <div className="center1">
                                    <div>
                                        <input
                                            className="resizedTextbox"
                                            type="text"
                                            id="fname"
                                            placeholder="Type your Question Here..."
                                            onChange={handleInputChange}
                                            value={qmessage}
                                            //value={transcript}
                                            onKeyPress={handleKeyPress} // Listen for Enter key press
                                            name="fname" />
                                        <button className='bg-secondary send-btn resizedbutton' onClick={handleSendMessage}>Send</button>
                                        {/* <div>
                                        {speak && browserSupportsSpeechRecognition ? (
                                            <div>
                                                <button onClick={handlePlay}>{isPaused ? "Resume" : "Play"}</button>
                                                <button onClick={handlePause}>Pause</button>
                                                <button onClick={handleStop}>Stop</button>
                                            </div>

                                        ) : (
  
                                            <div>
                                                {talk && browserSupportsSpeechRecognition ? ((<button

                                                    onMouseLeave={handleMouseLeave}
                                                    onTouchEnd={handleMouseLeave}
                                                >
                                                    Press to end
                                                </button>)) : (<button 
                                                    onMouseDown={handleMouseDown}
                                                    onTouchStart={handleMouseDown}
                                                >
                                                    Press to speak
                                                </button>)}</div>
                                        )}</div> */}
                                        {/* <div>
    <button
    onTouchStart={handleMouseDown}
    onTouchEnd={handleMouseLeave}
    style={{ userSelect:'none', padding: '10px', fontSize: '16px' }}
    >
    {talk ? 'Stop Recording' : 'Start Recording'}
    </button>
    </div> */}



                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Row>

                </Container>
                {/* </main> */}
                <Footer />
            </div>
        </ThemeProvider>

    );
}

export default WordByWordUpdateGita;




